import ClearIcon from "@mui/icons-material/Clear";
import React from "react";

import MDBox from "@/components/atoms/MDBox";
import { useFileType } from "@/hooks/use-type-file";
import { CurrentChatMessages } from "@/messages/chat/current-chat.messages";
import { FileTypes } from "@/types/files.types";

import DocumentPreview from "./components/DocumentPreview";

interface FilePreviewProps {
  file: File;
  onSelectFile: () => void;
  messages: CurrentChatMessages;
}

export function FilePreview({ file, onSelectFile, messages }: FilePreviewProps) {
  const { type, previewSrc } = useFileType(file);

  const renderContent = () => {
    if (type === FileTypes.IMAGE) {
      return (
        <img
          src={previewSrc!}
          alt="File preview"
          width={0}
          height={0}
          sizes="100vw"
          style={{ width: "70%", height: "auto", maxHeight: "100%" }}
        />
      );
    } else {
      return <DocumentPreview messages={messages} file={file} type={type} />;
    }
  };

  return (
    <MDBox
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      bgColor="grey-300"
      p={2}
      position="relative"
    >
      <MDBox position="absolute" top={8} left={15}>
        <ClearIcon onClick={onSelectFile} sx={{ fontSize: 30, cursor: "pointer" }} />
      </MDBox>
      {renderContent()}
    </MDBox>
  );
}
